// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate'
import App from './App'
import routes from './modules/routes'
import store from './store/index'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VeeValidate, {
  errorBagName: 'veeErrors',
  fieldsBagName: 'veeFields'
})
Vue.use(VueLodash, lodash)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

Vue.filter('numberDisplay', function (value) {
  return value ? value.toLocaleString() : 0
})

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js